import React, {useEffect, useState} from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogTitle,
    TableContainer,
    Table,
    TableHead,
    TableCell,
    TableBody,
    TableRow,
    Paper,
    Checkbox,
    TextField,
    Tooltip,
    FormControlLabel, FormControl, InputLabel, Select, MenuItem, Grid
} from '@mui/material';
import axios from 'axios';
import ConfirmationModal from "../ConfirmationModal/ConfirmationModal";
import LoaderCustomFixed from "../ConfirmationModal/LoaderCustomFixed";
import {IoIosCloseCircle} from "react-icons/io";
import CaseNotificationEnum from "../../enums/CaseNotiFicationEnum";
import {AiOutlineSearch} from "react-icons/ai";
import DatePicker from "react-datepicker";
import {ka} from "date-fns/locale";
import {MdMergeType, MdOutlineCleaningServices} from "react-icons/md";
import {Autocomplete} from "@mui/lab";

function MergeCaseDialogByCaseId({open, onClose, onMerge, users, roleId, userId, onExpertMerge, dateTime, fullName, previewHtml}) {
    const [caseId, setCaseId] = useState('');
    const [loading, setLoading] = useState(false);
    const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
    const [expertCaseData, setExpertCaseData] = useState([]);
    const [error, setError] = useState('');
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [createdByLoggedUser, serCreatedByLoggedUser] = useState(true);
    const [isCloseConfirmModalOpen, setIsCloseConfirmModalOpen] = useState(false);
    const urlParams = new URLSearchParams(window.location.search);
    const expertCaseId = urlParams.get('id');
    const [caseNumberFilter, setCaseNumberFilter] = useState('');
    const [createDateFilter, setCreateDateFilter] = useState(null);
    const [createDateFilterEnd, setCreateDateFilterEnd] = useState(null);
    const [selectedPermitTypeId, setSelectedPermitTypeId] = useState(null);
    const [lastChildren, setLastChildren] = useState([]);
    const [resetFilters, setResetFilters] = useState(false);
    const [regions, setRegions] = useState([]);
    const [cities, setCities] = useState([]);
    const [permitTypeIdList, setPermitTypeIdList] = useState([]);
    const [councils, setCouncils] = useState([]);
    const [populatedAreas, setPopulatedAres] = useState([]);
    const [regionFilter, setRegionFilter] = useState([]);
    const [cityFilter, setCityFilter] = useState([]);
    const [inspectFileCreatorID, setInspectFileCreatorID] = useState('');
    const [councilFilter, setCouncilFilter] = useState([]);
    const [populatedAreaFilter, setPopulatedAreaFilter] = useState([]);
    const rolesInGeorgian = {
        'HeadOfAgency': "სააგენტოს უფროსი",
        'DeputyHeadOfAgency': "უფროსის მოადგილე",
        'HeadOfDepartment': "სამმართველოს უფროსი",
        'Expert': "სპეციალისტი"
    };
    const [geoIds, setGeoIds] = useState({
        regionId: null,
        municipalityId: null,
        councilId: null,
        cityId: null
    });
    const findObjectTitleById = (objectId) => {
        const object = permitTypeIdList.find(child => child.id === objectId)
        return object ? object.description : ""
    };

    const fetchUserDetails = async (userId) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/User/GetOneUserByID?UserID=${userId}`);
            const data = response.data;
            return data.data;
        } catch (error) {
            return null;
        }
    };

    const deleteCase = async (caseId) => {
        const payload = {
            id: caseId,
        }

        await axios.put(`${process.env.REACT_APP_API_BASE_URL}/ DeleteCaseByAdminAndInternal`, payload);
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/GetPermitTypeTree`);
                const data = response.data.data;
                const findLastChildren = (nodes, rootParentId = null) => {
                    let lastChildren = [];
                    nodes.forEach(node => {
                        const currentRootParentId = rootParentId === null ? node.id : rootParentId;
                        if (node.childrenPermitTypes && node.childrenPermitTypes.length > 0) {
                            lastChildren = [...lastChildren, ...findLastChildren(node.childrenPermitTypes, currentRootParentId)];
                        } else {
                            lastChildren.push({id: node.id, description: node.title, parentId: currentRootParentId});
                        }
                    });
                    return lastChildren;
                };


                const lastChildren = findLastChildren(data);
                setPermitTypeIdList(lastChildren);
            } catch (error) {
            }
        };

        void fetchData();
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/GetAllDictionaryTypes`);
                if (response.data.success) {
                    extractIds(response.data.data);
                }
            } catch (error) {
            }
        };

        const extractIds = (data) => {
            const idMap = {
                'რეგიონი': 'regionId',
                'მუნიციპალიტეტი': 'municipalityId',
                'საკრებულო': 'councilId',
                'ქალაქი': 'cityId'
            };
            let newIds = {...geoIds};
            data.forEach(item => {
                const key = idMap[item.typesName];
                if (key) {
                    newIds[key] = item.id;
                }
            });
            setGeoIds(newIds);
        };
        void fetchData();
    }, []);

    useEffect(() => {
        const fetchCitiesForRegion = async () => {
            if (regionFilter.length > 0 && geoIds) {
                try {

                    const dictionaryRequests = regionFilter.map(regionId => ({
                        dictionaryTypeId: geoIds.municipalityId,
                        dictionaryId: regionId
                    }));
                    const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/GetAllDictionaryByDictionaryId`, {items: dictionaryRequests});
                    if (response.data && response.data.success) {
                        setCities(response.data.data);
                    } else {
                        setCities([]);
                    }
                } catch (error) {
                    setCities([]);
                }
            } else {
                setCities([]);
            }
        };

        void fetchCitiesForRegion();
    }, [regionFilter, geoIds]);


    useEffect(() => {
        const fetchCouncisForCities = async () => {
            if (cityFilter.length > 0 && geoIds) {
                try {
                    const dictionaryRequests = cityFilter.map(regionId => ({
                        dictionaryTypeId: geoIds.councilId,
                        dictionaryId: regionId
                    }));
                    const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/GetAllDictionaryByDictionaryId`, {items: dictionaryRequests});
                    if (response.data && response.data.success) {
                        setCouncils(response.data.data);
                    } else {
                        setCouncils([]);
                    }
                } catch (error) {
                    setCouncils([]);
                }
            } else {
                setCouncils([]);
            }
        };
        void fetchCouncisForCities();
    }, [cityFilter, geoIds]);


    useEffect(() => {
        const fetchPopulatedAreasForCouncils = async () => {
            if (councilFilter.length > 0 && geoIds) {
                try {

                    const dictionaryRequests = councilFilter.map(regionId => ({
                        dictionaryTypeId: geoIds.cityId,
                        dictionaryId: regionId
                    }));
                    const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/GetAllDictionaryByDictionaryId`, {items: dictionaryRequests});
                    if (response.data && response.data.success) {
                        setPopulatedAres(response.data.data);
                    } else {
                        setPopulatedAres([]);
                    }
                } catch (error) {
                    setPopulatedAres([]);
                }
            } else {
                setPopulatedAres([]);
            }
        };
        void fetchPopulatedAreasForCouncils();
    }, [councilFilter, geoIds]);


    const handleRegionChange = (event) => {
        const newValue = event.target.value;
        setRegionFilter(newValue);


        if (newValue.length > 0) {
            const fetchCitiesForRegions = async () => {
                try {
                    const dictionaryRequests = newValue.map(regionId => ({
                        dictionaryTypeId: geoIds.municipalityId,
                        dictionaryId: regionId
                    }));
                    const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/GetAllDictionaryByDictionaryId`, {items: dictionaryRequests});
                    if (response.data && response.data.success) {
                        setCities(response.data.data);
                    } else {
                        setCities([]);
                    }
                } catch (error) {
                    setCities([]);
                }
            };

            void fetchCitiesForRegions();
        } else {
            setCities([]);
        }
    };

    const handleCityChange = (event) => {
        const newValue = event.target.value;
        setCityFilter(newValue);

        if (newValue.length > 0) {
            const fetchCouncilsForCities = async () => {
                try {
                    const dictionaryRequests = newValue.map(regionId => ({
                        dictionaryTypeId: geoIds.councilId,
                        dictionaryId: regionId
                    }));
                    const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/GetAllDictionaryByDictionaryId`, {items: dictionaryRequests});
                    if (response.data && response.data.success) {
                        setCouncils(response.data.data);
                    } else {
                        setCouncils([]);
                    }
                } catch (error) {
                    setCouncils([]);
                }
            };

            void fetchCouncilsForCities();
        } else {
            setCouncils([]);
        }
    };
    const handleCouncilChange = (event) => {
        const newValue = event.target.value;
        setCouncilFilter(newValue);

        if (newValue.length > 0) {
            const fetchCitiesForRegions = async () => {
                try {
                    const dictionaryRequests = newValue.map(regionId => ({
                        dictionaryTypeId: geoIds.cityId,
                        dictionaryId: regionId
                    }));
                    const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/GetAllDictionaryByDictionaryId`, {items: dictionaryRequests});
                    if (response.data && response.data.success) {
                        setPopulatedAres(response.data.data);
                    } else {
                        setPopulatedAres([]);
                    }
                } catch (error) {
                    setPopulatedAres([]);
                }
            };

            void fetchCitiesForRegions();
        } else {
            setPopulatedAres([]);
        }
    };
    const handlePopulatedAreaChange = (event) => {
        const newValue = event.target.value;
        setPopulatedAreaFilter(newValue);
    };

    useEffect(() => {
        const fetchRegions = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/DictionaryTypesDetalisById?CategoryId=${geoIds.regionId}`);
                if (response.data && response.data.success) {
                    setRegions(response.data.data.resultlist);
                }
            } catch (error) {
            }
        };

        void fetchRegions();
    }, [geoIds]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/GetPermitTypeTree`);
                const data = response.data.data;

                const findLastChildren = (nodes) => {
                    let children = [];
                    nodes.forEach(node => {
                        if (node.childrenPermitTypes && node.childrenPermitTypes.length > 0) {
                            children = [...children, ...findLastChildren(node.childrenPermitTypes)];
                        } else {
                            children.push(node);
                        }
                    });
                    return children;
                };

                const lastNode = data[data.length - 1];
                const lastNodeChildren = findLastChildren([lastNode]);
                setLastChildren(lastNodeChildren);
            } catch (error) {
            }
        };

        void fetchData();
    }, [open]);

    const clearFilters = () => {
        setSelectedPermitTypeId(null)
        setCaseNumberFilter('');
        setInspectFileCreatorID('');
        setRegionFilter([]);
        setCityFilter([]);
        setCouncilFilter([]);
        setPopulatedAreaFilter([]);
        setCreateDateFilter(null);
        setResetFilters(true);
        setResetFilters(true);
        setLoading(true)
    };

    useEffect(() => {
        if (resetFilters) {
            void fetchCases();
            setCurrentPage(0);
            setResetFilters(false);
        }
    }, [resetFilters]);


    const handleCreateDateChange = (date) => {
        setCreateDateFilter(date);
    };
    const handleCreateDateEndChange = (date) => {
        setCreateDateFilterEnd(date);
    };
    const handleCaseNumberClick = (caseId) => {
        window.open(`/dashboard/mycases/casemanager?id=${caseId}`, '_blank');
    };
    const formatDate = (dateString) => {
        if (!dateString || dateString.startsWith('0001')) return '';
        const date = new Date(dateString);
        return `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getFullYear()} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;
    };

    const buildRequestBody = () => {
        const filters = [];
        const requestBody = {
            pageSize: 8,
            page: currentPage,
            sort: [{fieldName: 'id', desc: true}],
            filter: filters,
            creteByExpert: true,
            moveCaseToAgencyRegisterByExpert: false,
            filterByRequesterId: createdByLoggedUser
        };

        if (inspectFileCreatorID) {
            requestBody.caseRequesterIds = [inspectFileCreatorID];

        }

        const addFilter = (name, value, type = 'string', dynamic = false, greaterDateTime = false) => {
            if (value || value === 0) {
                let filterValue = value;
                if (type === 'dateTime') {
                    filterValue = value instanceof Date ? value.toISOString() : value;
                }
                filters.push({
                    fieldName: name,
                    [`${type}Value`]: filterValue,
                    dynamic,
                    greaterDateTime
                });
            }
        };

        addFilter('caseNumber', caseNumberFilter);
        addFilter('CreateDate', createDateFilter, 'dateTime', false, true);
        addFilter('CreateDate', createDateFilterEnd, 'dateTime');
        if (regionFilter.length > 0) {
            regionFilter.forEach(region => addFilter('Region', `-${region}-`, 'string', false));
        }
        if (cityFilter.length > 0) {
            cityFilter.forEach(city => addFilter('City', `-${city}-`, 'string', false));
        }
        if (councilFilter.length > 0) {
            councilFilter.forEach(council => addFilter('Council', `-${council}-`, 'string', false));
        }
        if (populatedAreaFilter.length > 0) {
            populatedAreaFilter.forEach(popArea => addFilter('populatedArea', `-${popArea}-`, 'string', false));
        }

        if (selectedPermitTypeId !== null) {
            requestBody.permitTypeId = selectedPermitTypeId;
        }

        return requestBody
    };

    const handleInspectUserChange = (event, newValue) => {
        if (newValue) {
            const newUserId = newValue.id;
            setInspectFileCreatorID(newUserId);
        } else {
            setInspectFileCreatorID('');
        }
    };

    const handlePermitTypeChangeRegistery = (event) => {
        const newValue = event.target.value === '' ? null : Number(event.target.value);
        setSelectedPermitTypeId(newValue);
    };

    const fetchCases = async () => {
        setLoading(true);
        setError('');
        const requestBody = buildRequestBody();

        try {
            const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/GetAllCasePublic`, requestBody);
            if (response.data.success) {
                setExpertCaseData(response.data.data.result);
                const totalItems = response.data.data.totalCount;
                setTotalPages(Math.ceil(totalItems / 8));
            } else {
                setError('Failed to fetch data');
            }
        } catch (err) {
            setError('An error occurred while fetching data');
            console.error(err);
        }
        setLoading(false);
    };

    const sendNotification = async () => {
        const headOfAgency = users.find(user => user.roleName === "HeadOfAgency");
        const deputyHeadOfAgency = users.find(user => user.roleName === "DeputyHeadOfAgency");

        const caseNotification = {
            nextStepUserId: roleId === "HEADOFAGENCY" ? deputyHeadOfAgency.id : headOfAgency.id,
            caseId: expertCaseId ? parseInt(expertCaseId, 10) : 0,
            documentId: null,
            action: CaseNotificationEnum.mergedCase.id,
            caseStatus: 8,
            viewed: true,
        };

        await axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddNewCaseNotification`, caseNotification);
    };

    const sendNotificationToHeadOfDepartment = async () => {
        const expertDepartment = await fetchUserDetails(userId);

        if (!expertDepartment) {
            console.error("Failed to fetch user details.");
            return;
        }

        const headOfDepartment = users.find(
            user => user.roleName.toLowerCase() === "headofdepartment" && user.departmentId === expertDepartment.departmentId
        );

        if (!headOfDepartment) {
            console.error("Head of department not found.");
            return;
        }

        const caseNotification = {
            nextStepUserId: headOfDepartment.id,
            caseId: expertCaseId ? parseInt(expertCaseId, 10) : 0,
            documentId: null,
            action: CaseNotificationEnum.requeredMergeCase.id,
            caseStatus: 8,
            viewed: false,
        };

        // Send the notification via POST request
        try {
            await axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddNewCaseNotification`, caseNotification);
        } catch (error) {
            console.error("Failed to send notification:", error);
        }
    };


    const handleRequestClose = () => {
        setIsCloseConfirmModalOpen(true);
    };

    const handleMerge = async () => {
        if (roleId !== "EXPERT") {
            const payload = {
                expertCaseId: caseId,
                caseId: parseInt(expertCaseId, 10),
                oldCaseNumber: ''
            };

            await sendNotification()
            try {
                await axios.post(`${process.env.REACT_APP_API_BASE_URL}/MargeCase`, payload);
                await deleteCase(caseId)
                onMerge();
                setIsConfirmModalOpen(false);
                onClose();

            } catch (error) {
                console.error('Error merging cases:', error);
            }
        } else if (roleId === "EXPERT") {
            const payload = {
                caseId: parseInt(expertCaseId, 10),
                requesttomovetoobjectregistrybyexpert: true,
                requesttomovetoobjectregistrybyexpertDenide: userId,
                mergeCaseID: caseId,
                answerOfHeadOfDepartment: false
            };
            await sendNotificationToHeadOfDepartment()
            try {
                await axios.post(`${process.env.REACT_APP_API_BASE_URL}/UpdateRequesttomovetoobjectregistrybyexpert`, payload);
                setIsConfirmModalOpen(false);
                onExpertMerge()
                onClose();
            } catch (error) {
                console.error('Error merging cases:', error);
            }
        }
        else{
            console.error("დაფიქსირდა შეცდომა")
        }

    };


    useEffect(() => {
        if (lastChildren.length !== 0) {
            void fetchCases();
        }

    }, [currentPage, createdByLoggedUser, lastChildren]);

    return (
        <Dialog open={open} onClose={handleRequestClose} PaperProps={{style: {minHeight: '90%', minWidth: '90%'}}}
                maxWidth="xl" fullWidth>
            <DialogTitle>განაცხადების გაერთიანება</DialogTitle>
            <IoIosCloseCircle className="upload-single-close-icon-text-editor"
                              onClick={handleRequestClose}
            />
            <div style={{padding: 10}}>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6} md={4}>
                        <TextField
                            label="განაცხადის ID"
                            value={caseNumberFilter}
                            onChange={(e) => setCaseNumberFilter(e.target.value)}
                            style={{width: 550}}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <Autocomplete
                            value={users.find(user => user.id === inspectFileCreatorID) || null}
                            options={users}
                            onChange={handleInspectUserChange}
                            getOptionLabel={(option) => `${option.firstName} ${option.lastName} (${rolesInGeorgian[option.roleName]})`}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="განაცხადის შემქმნელი"
                                    variant="outlined"
                                />
                            )}
                            noOptionsText="არაფერი მოიძებნა!"
                            fullWidth
                        />
                    </Grid>


                    <Grid item xs={12} sm={6} md={4}>
                        <DatePicker
                            selected={createDateFilter}
                            onChange={(dates) => {
                                const [start, end] = dates;
                                handleCreateDateChange(start);
                                handleCreateDateEndChange(end);
                            }}
                            startDate={createDateFilter}
                            endDate={createDateFilterEnd}
                            selectsRange
                            monthsShown={2}
                            customInput={
                                <TextField
                                    label="შეიქმნა"
                                    variant="outlined"

                                    style={{width: 550}} // Ensure the TextField takes the full width
                                />
                            }
                            autoComplete="off"
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            scrollableYearDropdown
                            dateFormat="dd/MM/yyyy"
                            locale={ka}
                        />
                    </Grid>


                    <Grid item xs={12} sm={6} md={4}>
                        <FormControl style={{width: 550}}>
                            <InputLabel>ობიექტი</InputLabel>
                            <Select
                                value={selectedPermitTypeId || ''}
                                label="ობიექტი"
                                onChange={handlePermitTypeChangeRegistery}
                            >
                                <MenuItem value={null}>
                                    <em>ყველა ობიექტი</em>
                                </MenuItem>
                                {lastChildren.map(({id, title}) => (
                                    <MenuItem key={id} value={id}>
                                        {title}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <FormControl style={{width: 550}}>
                            <InputLabel>რეგიონი</InputLabel>
                            <Select
                                multiple
                                value={regionFilter}
                                label="რეგიონი"

                                onChange={handleRegionChange}
                                renderValue={(selected) => selected.map((id) => regions.find(region => region.id === id)?.itemName).join(', ')}
                            >
                                {regions.map((region) => (
                                    <MenuItem key={region.id} value={region.id}>
                                        {region.itemName}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Tooltip title={regionFilter.length === 0 ? "ჯერ აირჩიეთ რეგიონი" : ""}>
                        <Grid item xs={12} sm={6} md={4}>
                            <FormControl style={{width: 550}} disabled={regionFilter.length === 0}>
                                <InputLabel>მუნიციპალიტეტი</InputLabel>
                                <Select
                                    multiple
                                    value={cityFilter}
                                    label="მუნიციპალიტეტი"
                                    onChange={handleCityChange}
                                    renderValue={(selected) => selected.map((id) => cities.find(region => region.id === id)?.typesName).join(', ')}

                                >
                                    {cities.map((city) => (
                                        <MenuItem key={city.id} value={city.id}>
                                            {city.typesName}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                    </Tooltip>



                    <Grid item xs={12} sm={6} md={4}>
                        <FormControlLabel
                            control={<Checkbox checked={createdByLoggedUser}
                                               onChange={(e) => serCreatedByLoggedUser(e.target.checked)}/>}
                            label="მხოლოდ ჩემი განაცხადების ჩვენება"
                        />
                    </Grid>


                </Grid>
                <div style={{display: "flex", gap: 10, marginTop: 30}}>
                    <Button
                        onClick={() => {
                            void fetchCases();
                            setCurrentPage(0);
                        }}
                        variant="contained"
                        color="primary"
                        fullWidth
                        endIcon={<AiOutlineSearch/>}
                    >
                        ძიება
                    </Button>
                    <Button
                        onClick={() => {
                            clearFilters();
                            setCurrentPage(0);
                        }}
                        variant="contained"
                        color="error"
                        fullWidth
                        endIcon={<MdOutlineCleaningServices/>}
                    >
                        ფილტრების წაშლა
                    </Button>
                </div>
            </div>

            {loading && lastChildren.length !== 0 ? (
                <div style={{minHeight: 600, paddingTop: "25%", minWidth: 1098}}><LoaderCustomFixed/></div>) : (
                <TableContainer component={Paper} style={{marginTop: 20}}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>განაცხადის ID</TableCell>
                                <TableCell>განაცხადის შემქმნელი</TableCell>
                                <TableCell>ობიექტი</TableCell>
                                <TableCell>შეიქმნა</TableCell>
                                <TableCell>რეგიონი</TableCell>
                                <TableCell>მუნიციპალიტეტი</TableCell>
                                <TableCell>არჩევა</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {expertCaseData.map((caseItem) => (
                                <TableRow key={caseItem.id}
                                          style={{backgroundColor: caseId === caseItem.id ? '#ADD8E6' : 'transparent'}}>
                                    <TableCell style={{color: "blue"}} component="th" scope="row">
                                        <span onClick={() => handleCaseNumberClick(caseItem.id)}
                                              style={{cursor: 'pointer'}}>
                                            {caseItem.caseNumber}
                                        </span>
                                    </TableCell>
                                    <TableCell>{caseItem.requesterName}</TableCell>
                                    <TableCell> {findObjectTitleById(caseItem.permitTypeId)}</TableCell>
                                    <TableCell>{formatDate(caseItem.createDate)}</TableCell>
                                    <TableCell>{caseItem.regionsNames}</TableCell>
                                    <TableCell>{caseItem.citysNames}</TableCell>
                                    <TableCell>
                                        <Checkbox
                                            checked={caseId === caseItem.id}
                                            onChange={() => setCaseId(caseItem.id)}
                                            color="primary"
                                        />
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            )}

            {error && <p style={{color: 'red'}}>{error}</p>}

            <DialogActions>

                <div style={{display: 'flex', justifyContent: 'center', flexGrow: 1}}>
                    <Button onClick={() => setCurrentPage(0)} disabled={currentPage === 0}>პირველი</Button>
                    <Button onClick={() => setCurrentPage(currentPage - 1)} disabled={currentPage === 0}>წინა</Button>
                    <Button onClick={() => setCurrentPage(currentPage + 1)}
                            disabled={currentPage >= totalPages - 1}>შემდეგი</Button>
                    <Button onClick={() => setCurrentPage(totalPages - 1)}
                            disabled={currentPage >= totalPages - 1}>ბოლო</Button>
                </div>

                    <Tooltip title={caseId === '' ? "აირჩიეთ განაცხადი" : ""}>
                        <div style={{cursor: caseId === '' ? "not-allowed" : "pointer"}}>
                            <Button
                                onClick={() => setIsConfirmModalOpen(true)}
                                disabled={caseId === '' || loading}
                                endIcon={<MdMergeType/>} // Add end icon here
                                style={{
                                    backgroundColor: caseId === '' ? '#f0f0f0' : '#1976d2', // Change color based on disabled state
                                    color: caseId === '' ? '#a9a9a9' : '#ffffff',
                                    padding: '10px 20px',
                                    fontWeight: 'bold', // Make the text bold
                                    boxShadow: caseId === '' ? 'none' : '0px 4px 6px rgba(0, 0, 0, 0.1)', // Add shadow
                                    borderRadius: '5px', // Rounded corners
                                }}
                            >
                                განაცხადის გაერთიანება
                            </Button>
                        </div>
                    </Tooltip>

            </DialogActions>
            <p style={{padding: '10px', fontSize: '16px', color: 'grey', textAlign: 'center', marginTop: '20px'}}>
                გვერდი: {currentPage + 1} ({totalPages}-დან)
            </p>
            <ConfirmationModal
                isOpen={isConfirmModalOpen}
                previewHtml={previewHtml}
                dateTime={dateTime}
                fullName={fullName}
                onRequestClose={() => setIsConfirmModalOpen(false)}
                onConfirm={handleMerge}
            />
            <ConfirmationModal
                isOpen={isCloseConfirmModalOpen}
                onRequestClose={() => setIsCloseConfirmModalOpen(false)}
                onConfirm={() => {
                    setIsCloseConfirmModalOpen(false);
                    onClose();
                }}
                modalText="დარწმუნებული ხართ რომ გსურთ ფანჯრის დახურვა?"
            />
        </Dialog>
    );
}

export default MergeCaseDialogByCaseId;
